import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../config/siteConfig";
import "../css/terms.scss";

function Terms() {
  return (
    <main id="main-content" className="terms-page">
      <figure className="terms-page__image">
        <img
          src="/img/terms-objects.jpg"
          alt="An overhead arrangement of homeware objects"
          width="1200"
          height="630"
          decoding="async"
        />
        <figcaption>Objects made with care, sold with clarity.</figcaption>
      </figure>

      <header className="terms-page__header" aria-labelledby="terms-title">
        <p className="terms-page__eyebrow">Information</p>
        <h1 id="terms-title">Terms of service</h1>
        <p>
          These terms apply when you browse this website or purchase an object
          from {siteConfig.legalName}. Please read them before placing an order.
        </p>
      </header>

      <div className="terms-page__body">
        <section aria-labelledby="terms-about">
          <h2 id="terms-about">1. About us</h2>
          <p>
            This website is operated by {siteConfig.legalName}. You can contact
            us at <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
            {" "}or by using the details on our <Link to="/contact">contact page</Link>.
          </p>
        </section>

        <section aria-labelledby="terms-products">
          <h2 id="terms-products">2. Objects and availability</h2>
          <p>
            We take care to describe and photograph every object accurately.
            Colour can vary between screens, and handmade work may carry small
            variations in form, finish or dimensions. These qualities are part
            of the work rather than faults.
          </p>
          <p>
            Many pieces are made in small runs or are unique. If an item becomes
            unavailable after checkout, we will contact you and issue a refund.
          </p>
        </section>

        <section aria-labelledby="terms-orders">
          <h2 id="terms-orders">3. Orders and payment</h2>
          <p>
            By submitting an order you confirm that the information supplied is
            accurate and that you are authorised to use the chosen payment
            method. An order acknowledgement does not guarantee acceptance. A
            contract is formed when we confirm dispatch.
          </p>
          <p>
            Prices are shown in the currency selected at checkout. Delivery
            charges, taxes or duties that apply to your destination are shown or
            described before payment wherever possible.
          </p>
        </section>

        <section aria-labelledby="terms-delivery">
          <h2 id="terms-delivery">4. Delivery</h2>
          <p>
            We aim to dispatch within the time shown on the product page or in
            our <Link to="/shipping">shipping information</Link>. Delivery dates
            are estimates unless expressly agreed otherwise. Risk passes to you
            when the parcel is delivered to the address supplied at checkout.
          </p>
        </section>

        <section aria-labelledby="terms-returns">
          <h2 id="terms-returns">5. Returns and cancellations</h2>
          <p>
            Eligible purchases may be returned by notifying us within 14 days
            of delivery. Bespoke, personalised, perishable and hygiene-sensitive
            items may be excluded where the law allows. Full instructions are
            set out in our <Link to="/returns">returns policy</Link>.
          </p>
        </section>

        <section aria-labelledby="terms-liability">
          <h2 id="terms-liability">6. Responsibility</h2>
          <p>
            Nothing in these terms excludes rights or liabilities that cannot be
            excluded by law. We are not responsible for losses that were not a
            foreseeable result of our breach, or for business losses arising
            from a purchase made as a consumer.
          </p>
        </section>

        <section aria-labelledby="terms-site">
          <h2 id="terms-site">7. Website use and privacy</h2>
          <p>
            Site content is provided for personal, non-commercial use. Text,
            photography and design may not be reproduced without permission.
            Our handling of personal information is explained in the{" "}
            <Link to="/privacy">privacy policy</Link>.
          </p>
        </section>

        <section aria-labelledby="terms-law">
          <h2 id="terms-law">8. Governing law</h2>
          <p>
            These terms are governed by the laws of Hong Kong. Consumers retain any
            mandatory protections and rights to bring proceedings available in
            the place where they live.
          </p>
        </section>
      </div>
    </main>
  );
}

export default Terms;
